import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { RecommendationsMessages } from './recommendations-messages.model';

@Injectable()
export class RecommendationsMessagesService {

  constructor(private http: HttpClient) { }


}
